import { Box, Container, Typography } from "@mui/material";
import { styles } from "../../styles"
const DrawHeroComponent = () => {
    return (
        <Box sx={styles.pageContainer}>
            <Box sx={styles.bannerImage}>
                <Box
                    px={{ xs: 1, sm: 1, md: 4, lg: 4 }}
                    py={{ xs: 1, sm: 1, md: 2, lg: 6 }}
                    sx={{
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "flex-start",
                    }}
                >
                    <Typography sx={styles.bannerTitle}>Contest List</Typography>
                    <Typography sx={styles.bannerHeading}>
                        Your Ticket To A Life-Changing Win!
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};
export default DrawHeroComponent